// WhattsAppMessages.jsx (updated with Random number option)
import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import { ArrowLeft } from "feather-icons-react/build/IconComponents";
import { useSelector } from "react-redux";
import { APIgetPublicUsers } from "../../api/settings.ts";
import axios from "axios";

const STATUSES = ["queued", "sending", "sent", "failed", "delivered", "read"];

// numbers are generating at backend
const COUNTRY_META = {
  PK: { code: "92", localLength: 10 },
  US: { code: "1", localLength: 11 },
  GH: { code: "233", localLength: 8 },
  JM: { code: "1", localLength: 8 },
  JP: { code: "81", localLength: 9 }
};
function formatTs(ms) {
  if (!ms) return "-";
  try {
    return new Date(Number(ms)).toLocaleString();
  } catch {
    return String(ms);
  }
}
const WhattsAppMessages = () => {
  const route = all_routes;
  const l = useSelector((s) => s.language || "en");
  const t = useSelector((s) => s.translation || "en");

   // list state
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  // filters / paging
  // const [status, setStatus] = useState("");
  const [number, setNumber] = useState("");
  const [batchId, setBatchId] = useState("");
  const [limit, setLimit] = useState(20);
  const [skip, setSkip] = useState(0);
  const [sort, setSort] = useState("desc"); // by createdAt


  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false);
  const [message, setMessage] = useState("");
  const [country, setCountry] = useState("PK");
  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState(null);
  const fileRef = useRef();

  // NEW: random generation UI state
  const [generateRandom, setGenerateRandom] = useState(false);
  const [randomCount, setRandomCount] = useState(1);

  // QR / connection UI state
  const [qrOpen, setQrOpen] = useState(false);
  const [qrImageSrc, setQrImageSrc] = useState(null); // data url or chart API
  // const [qrRaw, setQrRaw] = useState(null);
  const [clientReady, setClientReady] = useState(false);
  const [polling, setPolling] = useState(false);

  useEffect(() => { loadUsers(); checkStatus(); }, []);

  const loadUsers = useCallback(async () => {
    setLoadingUsers(true);
    try {
      const res = await APIgetPublicUsers({});
      setUsers(res?.response || []);
    } catch (e) {
      console.error("Failed to load users", e);
    } finally {
      setLoadingUsers(false);
    }
  }, []);

  useEffect(() => {
    const urls = files.map((f) => ({ file: f, url: URL.createObjectURL(f) }));
    setPreviews(urls);
    return () => { urls.forEach(u => URL.revokeObjectURL(u.url)); };
  }, [files]);

  const toggleSelect = useCallback((id) => {
    setSelectedIds(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      setSelectAll(false);
      return next;
    });
  }, []);

  const toggleSelectAll = useCallback(() => {
    setSelectAll(v => {
      const next = !v;
      setSelectedIds(() => next ? new Set(users.map(u => u._id)) : new Set());
      return next;
    });
  }, [users]);

  const selectedCustomerNumbers = useMemo(() => {
    if (selectAll) return users.map(u => u?.profile?.phoneNumber).filter(Boolean);
    return users.filter(u => selectedIds.has(u._id)).map(u => u?.profile?.phoneNumber).filter(Boolean);
  }, [users, selectedIds, selectAll]);

  const handleFiles = useCallback((e) => {
    const list = Array.from(e.target.files || []);
    setFiles(list.slice(0, 12));
  }, []);

  const validateBeforeSend = useCallback(() => {
    if (!message.trim() && files.length === 0) {
      setStatus({ type: "error", text: "Please provide a message or attach images." });
      return false;
    }
    if (selectedCustomerNumbers.length === 0 && !generateRandom) {
      setStatus({ type: "warn", text: "No customers selected — will send only to generated numbers." });
      // allow sending but warn; return true
    }
    if (generateRandom) {
      const c = parseInt(String(randomCount || "0"), 10) || 0;
      if (c <= 0 || c > 10) {
        setStatus({ type: "error", text: "Random count must be between 1 and 10." });
        return false;
      }
    }
    return true;
  }, [message, files, selectedCustomerNumbers, generateRandom, randomCount]);

  // NEW: check server-side whatsapp client status
  const checkStatus = useCallback(async () => {
    try {
      const res = await axios.get("whatsapphealth");
      if (res?.data?.clientReady) {
        setClientReady(true);
      } else {
        setClientReady(false);
      }
      return res?.data;
    } catch (err) {
      console.warn("Status check failed", err?.message || err);
      setClientReady(false);
    }
  }, []);

  const disconnectWhatsApp = useCallback(async () => {
    const ok = window.confirm("Disconnect WhatsApp from this server?");
    if (!ok) return;
    setStatus({ type: "info", text: "Disconnecting..." });
    try {
    const res = await axios.post("whatsappdisconnect");
    if (res?.data?.status === "ok" || res?.data?.status === "success") {
    setClientReady(false);
    setQrOpen(false);
    setQrImageSrc(null);
    setStatus({ type: "success", text: "WhatsApp disconnected." });
    } else {
    setStatus({ type: "error", text: res?.data?.message || "Failed to disconnect" });
    }
    } catch (err) {
    console.error("disconnect error", err);
    setStatus({ type: "error", text: err?.response?.data?.message || err?.message || "Failed to disconnect" });
    }
  }, []);

   const page = Math.floor(skip / limit) + 1;
  const pages = Math.max(1, Math.ceil(total / limit));

  const fetchMessages = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        limit: String(limit),
        skip: String(skip),
        sort,
      };
      if (status) params.status = status;
      if (number) params.number = number;
      if (batchId) params.batchId = batchId;

      // adjust the path if your route differs
      const res = await axios.get("listwhatsappmessages", { params });
      
      const data = res?.data || [];
console.log("data?.items",data?.items)
      setRows(data?.items || []);
      setTotal(Number(data?.total || 0));
    } catch (e) {
      console.error("listwhatsappmessages failed:", e);
    } finally {
      setLoading(false);
    }
  }, [limit, skip, sort, status, number, batchId]);

  useEffect(() => {
    fetchMessages();
  }, [fetchMessages]);

  const goPage = (p) => {
    const clamped = Math.max(1, Math.min(p, pages));
    setSkip((clamped - 1) * limit);
  };

  // NEW: poll status every 3s until ready or timeout after e.g. 2 minutes
  const waitForReady = useCallback(async (timeoutMs = 120000) => {
    if (polling) return;
    setPolling(true);
    setStatus({ type: "info", text: "Waiting for WhatsApp client to become ready..." });
    const start = Date.now();
    const poll = async () => {
      try {
        const res = await axios.get("whatsapphealth");
        if (res?.data?.clientReady) {
          setClientReady(true);
          setPolling(false);
          setQrOpen(false);
          setStatus({ type: "success", text: "WhatsApp connected!" });
          return;
        }
      } catch (e) {
        // ignore transient errors
      }
      if (Date.now() - start > timeoutMs) {
        setPolling(false);
        setStatus({ type: "error", text: "Timed out waiting for WhatsApp to connect. Try scanning again." });
        return;
      }
      setTimeout(poll, 3000);
    };
    poll();
  }, [polling]);

  // Then define fetchQr with waitForReady in dependencies
  const fetchQr = useCallback(async () => {
    setQrImageSrc(null);
    setQrOpen(true);
    setPolling(false);
    setStatus({ type: "info", text: "Requesting QR..." });

    try {
      const res = await axios.get("getwhatsappqrcode");
      if (res?.data?.qrDataUrl) {
        setQrImageSrc(res.data.qrDataUrl);
      } else if (res?.data?.qr) {
        const qrContent = encodeURIComponent(res.data.qr);
        const googleQrUrl = `https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=${qrContent}&chld=L|1`;
        console.log("Generated QR URL:", googleQrUrl); // Debug URL
        setQrImageSrc(googleQrUrl);
      } else {
        setStatus({ type: "error", text: "Failed to get QR code" });
        return;
      }

      setStatus({ type: "info", text: "Scan the QR with WhatsApp on phone (WhatsApp > Settings > Linked devices > Link a device)." });
      waitForReady();
    } catch (err) {
      console.error("fetchQr error", err);
      setStatus({ type: "error", text: "Failed to request QR" });
    }
  }, [waitForReady]);

  // handleSend posts to /api/whatsapp/send
  const handleSend = useCallback(async () => {
    if (!validateBeforeSend()) return;
    setSending(true);
    setStatus({ type: "info", text: "Preparing..." });

    try {
      const recipients = Array.from(new Set([...(selectedCustomerNumbers || [])]));
      const fd = new FormData();
      fd.append("message", message);
      fd.append("country", country);
      fd.append("recipients", JSON.stringify(recipients));
      // include random generation flags
      if(generateRandom == true)
      {
        fd.append("generateRandom", generateRandom ? "true" : "false");
        fd.append("randomCount", String(randomCount || 0));
      }
      files.forEach((f) => fd.append("files", f, f.name));

      const res = await axios.post("sendwhatsappmessages", fd, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (res?.data?.status === 'success' || res?.data?.status === 'ok') {
        setStatus({ type: "success", text: "Message queued for sending." });
        setMessage("");
        setFiles([]);
        setGenerateRandom(false);
        setRandomCount(1);
        if (fileRef.current) fileRef.current.value = "";
      } else {
        setStatus({ type: "error", text: res?.data?.message || "Send failed" });
      }
    } catch (err) {
      console.error(err);
      setStatus({ type: "error", text: err?.response?.data?.message || err?.message || "Failed to send" });
    } finally {
      setSending(false);
    }
  }, [message, files, country, selectedCustomerNumbers, validateBeforeSend, generateRandom, randomCount]);

  return (
    <div className={`${l === "ar" ? "page-wrapper-rtl" : "page-wrapper"}`}>
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>{t?.[l]?.["whattsapp_messages"] || "WhattsApp Messages"}</h4>
              <h6>{t?.[l]?.["create_whattsapp_messages"] || "Create WhattsApp Messages"}</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <div className="page-btn">
                <Link to={route.productlist} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                  {t?.[l]?.["back_to_post"] || "Back to Post"}
                </Link>
              </div>
            </li>
          </ul>
        </div>

        <div className="card p-3">
          <div className="mb-3 d-flex justify-content-between align-items-center">
            <div>
              <label className="form-label me-2">{t?.[l]?.["whatsApp_status"] || "WhatsApp status"}:</label>
              <strong className={clientReady ? "text-success" : "text-warning"}>
                {clientReady ? "Connected" : "Not connected"}
              </strong>
            </div>
            <div>
              <button type="button" className="btn btn-sm btn-outline-primary me-2" onClick={checkStatus}>{t?.[l]?.["check"] || "Check"}</button>
              <button type="button" className="btn btn-sm btn-primary me-2" onClick={fetchQr}>{t?.[l]?.["scan_qr_connect"] || "Scan QR / Connect"}</button>
              <button type="button" className="btn btn-sm btn-outline-danger" onClick={disconnectWhatsApp} disabled={!clientReady}>{t?.[l]?.["disconnect"] || "Disconnect"}</button>

              
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">{t?.[l]?.["country"] || "Country"}</label>
            <select className="form-select" value={country} onChange={e => setCountry(e.target.value)}>
              {Object.keys(COUNTRY_META).map(k => 
                <option key={k} value={k}> {t?.[l]?.[k] || k} (+{COUNTRY_META[k].code})</option>
              )}
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">{t?.[l]?.["message"] || "Message"}</label>
            <textarea className="form-control" rows={5} value={message} onChange={e => setMessage(e.target.value)} />
          </div>

          <div className="mb-3">
            <label className="form-label">{t?.[l]?.["attach_images_multiple"] || "Attach images (multiple)"}</label>
            <input ref={fileRef} type="file" accept="image/*" multiple className="form-control" onChange={handleFiles} />
            <div className="d-flex flex-wrap mt-2">
              {previews.map(p => (
                <div key={p.url} style={{width:80, height:80, marginRight:8, marginBottom:8, position:"relative"}}>
                  <img src={p.url} alt="" style={{width:"100%", height:"100%", objectFit:"cover", borderRadius:4}} />
                </div>
              ))}
            </div>
          </div>

          <hr />

          <div className="mb-3">
            {/* Random generation controls */}
            <label className="form-label"><strong>{t?.[l]?.["random_numbers"] || "Random numbers"}</strong></label>
            <div className="d-flex align-items-center">
              <div className="form-check me-3">
                <input
                  id="gen-random"
                  className="form-check-input"
                  type="checkbox"
                  checked={generateRandom}
                  onChange={e => setGenerateRandom(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="gen-random">{t?.[l]?.["generate_random_numbers"] || "Generate random numbers"}</label>
              </div>

              <div style={{width: 130, marginLeft: 12}}>
                <input
                  type="number"
                  className="form-control"
                  min={1}
                  max={10}
                  value={randomCount}
                  onChange={e => {
                    const v = Math.max(1, Math.min(10, parseInt(e.target.value || "1", 10) || 1));
                    setRandomCount(v);
                  }}
                  disabled={!generateRandom}
                />
                <small className="text-muted">{t?.[l]?.["Count_1_10"] || "Count (1-10)"}</small>
              </div>
            </div>
          </div>

          <div className="mb-2">
            <div className="d-flex align-items-center justify-content-between">
              {/* <strong></strong> */}
              <div>
                <label >
                  <input type="checkbox" checked={selectAll} onChange={toggleSelectAll} /> {t?.[l]?.["select_all_customers"] || "Select all customers"}
                </label>
                <button type="button" className="btn btn-sm btn-outline-primary me-2" onClick={loadUsers} disabled={loadingUsers} style={{marginLeft:8}}>
                  {loadingUsers ? "Refreshing..." : "Refresh"}
                </button>
                
              </div>
            </div>
            <div style={{maxHeight: 220, overflowY: "auto", marginTop: 8, border: "1px solid #eee", padding: 8, borderRadius: 4}}>
              {users.length === 0 ? (
                <div className="text-muted">{t?.[l]?.["no_customers_loaded"] || "No customers loaded"}</div>
              ) : users.map(u => (
                <div key={u._id} className="form-check">
                  <input className="form-check-input" type="checkbox" checked={selectAll || selectedIds.has(u._id)} onChange={() => toggleSelect(u._id)} id={`c-${u._id}`} />
                  <label className="form-check-label" htmlFor={`c-${u._id}`}>
                    {u.profile?.firstName || "-"} {u.profile?.lastName || ""} — {u.profile?.phoneNumber || u.email}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-3 d-flex align-items-center">
            <button className="btn btn-primary" disabled={sending || !clientReady} onClick={handleSend}>
              {sending ? "Sending..." : "Send WhatsApp"}
            </button>
            <div style={{marginLeft: 12}}>
              <small className={status?.type === "error" ? "text-danger" : status?.type === "success" ? "text-success" : "text-muted"}>
                {status?.text}
              </small>
            </div>
          </div>

        </div>

        {/* QR modal */}
        {qrOpen && (
          <div style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
            display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
          }}>
            <div style={{ background: '#fff', padding: 20, borderRadius: 8, width: 360, textAlign: 'center' }}>
              <h5>{t?.[l]?.["scan_qr_to_link_whatsapp"] || "Scan QR to link WhatsApp"}</h5>
              <div style={{ margin: '12px 0' }}>
              {qrImageSrc ? (
                <img 
                  src={qrImageSrc} 
                  alt="WhatsApp QR Code" 
                  style={{ 
                    width: 300, 
                    height: 300,
                    display: 'block',
                    margin: '0 auto'
                  }} 
                />
              ) : (
                <div style={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">{t?.[l]?.["loading_qr_code"] || "Loading QR code..."}</span>
                  </div>
                </div>
              )}
              </div>
              <div style={{ fontSize: 12, color: '#666' }}>
                {t?.[l]?.["use_whatsapp_settings_linked_devices_link_a_device"] || "Use WhatsApp → Settings → Linked devices → Link a device"}
              </div>
              <div className="mt-3 d-flex justify-content-between">
                <button className="btn btn-secondary" onClick={() => { setQrOpen(false); setPolling(false); }}>{t?.[l]?.["close"] || "Close"}</button>
                <button className="btn btn-outline-primary" onClick={() => { setQrImageSrc(null); fetchQr(); }}>{t?.[l]?.["refresh_qr"] || "Refresh QR"}</button>
              </div>
            </div>
          </div>
        )}

      </div>

      <div className="card p-3">
      <h5 className="mb-3">{t?.[l]?.["whatsApp_message_statuses"] || "WhatsApp Message Statuses"}</h5>

      {/* Filters */}
      <div className="row g-2 mb-3">
        <div className="col-12 col-md-2">
          <label className="form-label">{t?.[l]?.["status"] || "Status"}</label>
          <select
            className="form-select"
            value={status}
            onChange={(e) => {
              setStatus(e.target.value);
              setSkip(0);
            }}
          >
            <option value="">{t?.[l]?.["all"] || "All"}</option>
            {STATUSES.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-md-3">
          <label className="form-label">{t?.[l]?.["number_contains"] || "Number contains"}</label>
          <input
            className="form-control"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            placeholder="92300…"
          />
        </div>

        <div className="col-12 col-md-3">
          <label className="form-label">{t?.[l]?.["batch_id"] || "Batch ID"}</label>
          <input
            className="form-control"
            value={batchId}
            onChange={(e) => setBatchId(e.target.value)}
            placeholder="optional"
          />
        </div>

        <div className="col-6 col-md-2">
          <label className="form-label">{t?.[l]?.["sort"] || "Sort"}</label>
          <select
            className="form-select"
            value={sort}
            onChange={(e) => setSort(e.target.value)}
          >
            <option value="desc">{t?.[l]?.["newest_first"] || "Newest first"}</option>
            <option value="asc">{t?.[l]?.["oldest_first"] || "Oldest first"}</option>
          </select>
        </div>

        <div className="col-6 col-md-2 d-flex align-items-end">
          <button
            className="btn btn-outline-secondary w-100"
            onClick={() => {
              setSkip(0);
              fetchMessages();
            }}
            disabled={loading}
          >
            {loading ? "Filtering…" : "Apply"}
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>{t?.[l]?.["number"] || "Number"}</th>
              <th>{t?.[l]?.["country"] || "Country"}</th>
              <th>{t?.[l]?.["status"] || "Status"}</th>
             
              <th>{t?.[l]?.["error"] || "Error"}</th>
              <th>{t?.[l]?.["created"] || "Created"}</th>
              <th>{t?.[l]?.["updated"] || "Updated"}</th>
            </tr>
          </thead>
          <tbody>
            {rows?.length === 0 && (
              <tr>
                <td colSpan={9} className="text-muted">
                  {loading ? "Loading…" : "No messages found"}
                </td>
              </tr>
            )}
            {rows?.map((r, idx) => (
              <tr key={r._id || idx}>
                <td>{skip + idx + 1}</td>
                <td>{r.number}</td>
                <td>{r.country || "-"}</td>
                <td>
                  <span
                    className={`badge bg-${
                      r.status === "failed"
                        ? "danger"
                        : r.status === "read"
                        ? "success"
                        : r.status === "delivered"
                        ? "info"
                        : r.status === "sent"
                        ? "primary"
                        : "secondary"
                    }`}
                  >
                    {r.status}
                  </span>
                </td>
                
                <td style={{ maxWidth: 260 }} className="text-danger">
                  <small
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "inline-block",
                      maxWidth: "100%",
                    }}
                  >
                    {r.error || ""}
                  </small>
                </td>
                <td>
                  <small>{formatTs(r.createdAt)}</small>
                </td>
                <td>
                  <small>{formatTs(r.updatedAt)}</small>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="d-flex align-items-center justify-content-between mt-2">
        <div>
          <small className="text-muted">
            Total: {total} • {t?.[l]?.["page"] || "Page"} {page} / {pages}
          </small>
        </div>
        <div className="btn-group">
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => goPage(1)}
            disabled={page === 1}
          >
            ⏮ {t?.[l]?.["first"] || "First"}
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => goPage(page - 1)}
            disabled={page === 1}
          >
            ◀ {t?.[l]?.["prev"] || "Prev"}
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => goPage(page + 1)}
            disabled={page >= pages}
          >
            {t?.[l]?.["next"] || "Next"} ▶
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => goPage(pages)}
            disabled={page >= pages}
          >
            {t?.[l]?.["last"] || "Last"} ⏭
          </button>
        </div>
        <div className="d-flex align-items-center">
          <label className="me-2 mb-0">
            <small>{t?.[l]?.["rows"] || "Rows"}</small>
          </label>
          <select
            className="form-select form-select-sm"
            style={{ width: 90 }}
            value={limit}
            onChange={(e) => {
              setLimit(parseInt(e.target.value, 10));
              setSkip(0);
            }}
          >
            {[10, 20, 50, 100].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
    </div>
  );
};

export default WhattsAppMessages;